import get from 'lodash/get';

import { getFormBuilder } from './index';
import { DEFAULT } from '../reducers/formLibrary';
import { getEntitiesFormLibrary } from '../../../entities/form/selectors';

const FORM_LIBRARY = 'formLibrary';

const getFormLibrary = (state) => {
    const formBuilderState = getFormBuilder(state);
    return get(formBuilderState, FORM_LIBRARY);
};

export const getFormLibraryList = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'formList', []);
};

export const getFormLibraryPage = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'page', 0);
};

export const getPageLimitReached = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'pageLimitReached', false);
};

export const getFormLibraryStatus = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'status', DEFAULT);
};

export const getScaledFormModalStatus = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'scaledFormModalStatus', false);
};

export const getFormLibrarySearchTerm = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'searchTerm', '');
};

export const getEventCount = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'eventCount', 0);
};

export const getThemeCount = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'themeCount', 0);
};

export const getFormLibraryError = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'inlineError', false);
};

/**
 *
 * @param {object} state
 * @param {int} id
 * @return {string} name of form
 */
export const getFormLibraryName = (state, id) => {
    const formLibraryList = getFormLibraryList(state);
    const form = formLibraryList.find((formLibrary) => formLibrary.id === id);
    return get(form, 'name', '');
};

export const getIsFormSavedInLibrary = (state, id) => getEntitiesFormLibrary(state, id) != null;

export const getFormLibraryFormId = (state) => {
    const formLibraryState = getFormLibrary(state);
    return get(formLibraryState, 'formLibraryFormId');
};
